import { render, staticRenderFns } from "./IconWait.vue?vue&type=template&id=0e3a556a&scoped=true&"
import script from "./IconWait.vue?vue&type=script&lang=ts&"
export * from "./IconWait.vue?vue&type=script&lang=ts&"
import style0 from "./IconWait.vue?vue&type=style&index=0&id=0e3a556a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3a556a",
  null
  
)

export default component.exports